import React from "react";
import { Navigate } from "react-router-dom";
import { getDivision } from "../../Services/LocalStorageService";

const DivisionGuard = ({ children }) => {
  const division = getDivision();  // 👈 Use the helper

  if (!division) {
    return <Navigate to="/division-cards" replace />;
  }

  return children;
};

export default DivisionGuard;